<template>
  <div class="flex xl:justify-center font-roboto break-words">
    <table v-if="tableData && tableData.length > 0" class="w-full border-separate border-spacing-y-1.5 px-1.5">
      <thead>
        <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
          <th v-for="(header, index) in tableHeaders" :key="header.title" @click="sortClicked(header)"
            class="px-2 py-[12px] text-sm font-medium cursor-pointer" :class="{
              'rounded-l-lg': index === 0,
              'rounded-r-lg': index === tableHeaders.length - 1,
              '!bg-customBlue-100 text-white': true,
            }">
            <span class="flex items-center">
              <span v-if="header.sort_applicable == '1'" class="max-h-5">
                <button v-if="header.sort_direction == ''" class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
                <button v-else-if="header.sort_direction == 'ASC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/asc.svg" alt="Sorting Ascending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else-if="header.sort_direction == 'DESC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/desc.svg" alt="Sorting Descending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
              </span>
              {{ header.title }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
        <tr v-for="(item, rowIndex) in tableData" :key="rowIndex"
          class="group mt-1 transition-all duration-300 py-2 rounded-lg  shadow-[0_0_10px_0_#0000001f] cursor-pointer" @click="()=> $emit('itemClick', item)" >
          <td v-for="(header, colIndex) in tableHeaders" :key="header.data_value" class="px-[8px] py-[9px] bg-white text-sm font-medium" :class="{
            'rounded-l-lg': colIndex === 0,
            'rounded-r-lg': colIndex === tableHeaders.length - 1,
            'mobile:!min-w-[125px] mobile:!max-w-[110px] border-y border-l border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'agreement_id',
            'mobile:!min-w-[60px]  mobile:!max-w-[120px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'partner_company_logo',
            'mobile:!min-w-[90px]  mobile:!max-w-[110px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'consumer_name',
            'mobile:!min-w-[50px]  mobile:!max-w-[170px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'plan_name',
            'mobile:!min-w-[100px] mobile:!max-w-[200px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'trade_name',
            'mobile:!min-w-[95px]  mobile:!max-w-[150px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'sale_date',
            'mobile:!min-w-[140px] mobile:!max-w-[130px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'activation_date',
            'mobile:!min-w-[80px]  mobile:!max-w-[100px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'total_amount',
            'mobile:!min-w-[120px] mobile:!max-w-[130px] border-y border-r border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'status_slug',
          }">
            <template v-if="header.data_value === 'activation_date' ">
              <span>
                {{ item[header.data_value] }}
              </span>
            </template>

            <template v-else-if="header.data_value === 'sale_date' ">
              <span>
                {{ $helper.formattedDate(item.sale_date) }}
              </span>
            </template>


            <template v-else-if="header.data_value === 'total_amount'">
              ${{ $helper.isEmpty(item.total_amount) ? '-' : $helper.formatAmount(item.total_amount) }}

            </template>
            <template v-else-if="header.data_value === 'partner_company_logo'">
              <img :src="item[header.data_value]" alt="Partner Company Logo" class="w-12 h-12 object-contain max-h-10">
            </template>
            <template v-else-if="header.data_value === 'status_slug'">
            
              <p v-if="item.status_slug == 'pending'"
                class="inline-block text-center py-[1px] px-[10px] text-sm rounded-[5px] mb-0 text-white bg-[#F39C12]">
                {{ item.status_text }}</p>
              <p v-else-if="item.status_slug == 'approved'"
                class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741]">
                {{ item.status_text }}</p>
              <p v-else-if="item.status_slug == 'payment_failed'"
                class="inline-block text-center py-[1px] px-[3px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E]">
                {{ item.status_text }}</p>
              <p v-else-if="item.status_slug == 'rejected'"
                class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E]">
                {{ item.status_text }}</p>
              <p v-else-if="item.status_slug == 'active'"
                class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#65B741] capitalize">
                {{ item.status_text }}</p>
              <p v-else-if="item.status_slug == 'cancelled'"
                class="inline-block text-center py-[1px] px-[15px] text-sm rounded-[5px] mb-0 text-white bg-[#D7385E] capitalize">
                {{ item.status_text }}</p>
              <p v-else>-</p>
            </template>
            <template v-else>
              {{ item[header.data_value] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]">No Record Found</p>
  </div>
</template>

<script>
export default {
  props: ["tableHeaders", "tableData", "sortClicked", "isLoading"],
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'approved': '#65B741',
        'pending': '#F39C12',
        'rejected': '#D7385E',
      };
      return statusClasses[status] || 'bg-gray-500';
    },
    // getTextStatusClass(textStatus) {
    //     const textStatusClasses = {
    //         'Evaluation Completed': 'text-cyan-500',
    //         'Inspection Started': 'text-blue-500',
    //     };
    //     return textStatusClasses[textStatus];
    // }
  }
};
</script>
